module.exports = __webpack_public_path__ + "static/img/support_4.15ac316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/channels_support/support_4.png
// module id = szjQ
// module chunks = 94